"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setColorSchemas = void 0;
const elements_tailwind_styles_1 = require("@hydrogen/elements.tailwind-styles");
const utils_1 = require("./utils");
const types_1 = require("./types");
const applySchema = (schema) => {
    const reducedSchema = (0, utils_1.reduceSchema)(schema);
    return (Object.entries(reducedSchema)
        .reduce((acc, [key, value]) => (`${acc}
       --${(0, utils_1.camel2KebabCase)(key)}: ${(0, utils_1.getExistProperty)(reducedSchema, value)};`), ''));
};
function insertSchema({ defaultSchema, dark }) {
    var _a;
    (_a = document.getElementById('theme-schema')) === null || _a === void 0 ? void 0 : _a.remove();
    document.head.insertAdjacentHTML('beforeend', `<style id="theme-schema">
                :root{
                    ${applySchema((0, utils_1.checkSchema)(defaultSchema, elements_tailwind_styles_1.themeSchema.defaultSchema))}
                    }
                 :root[mode=dark]{
                    ${dark ? applySchema((0, utils_1.checkSchema)(dark, elements_tailwind_styles_1.themeSchema.defaultSchema)) : ''}
                    }
                </style>
`);
}
function setColorSchemas(schemas) {
    if ((0, types_1.isColorsSchemas)(schemas)) {
        insertSchema(schemas);
    }
    else {
        insertSchema({ defaultSchema: schemas });
    }
}
exports.setColorSchemas = setColorSchemas;
//# sourceMappingURL=theme.js.map